export default "__VITE_ASSET__DLLe9v8N__"